import { Injectable, EventEmitter } from '@angular/core';
import { OnAddEditGroupClass } from './on-add-edit-group-class';

@Injectable({
    providedIn: 'root'
})
export class GlobalEventsService {
    public onAddEditGroupClass$: EventEmitter<OnAddEditGroupClass>;
    public onGroupClassAdded$: EventEmitter<{ ids: string[] }>;
    public onGroupClassUpdated$: EventEmitter<{ id: string }>;

    constructor() {
        console.log('Initialize of global events service');

        this.onAddEditGroupClass$ = new EventEmitter<OnAddEditGroupClass>();
        this.onGroupClassAdded$ = new EventEmitter<{ ids: string[] }>();
        this.onGroupClassUpdated$ = new EventEmitter<{ id: string }>();
    }
}
